import { useQuery } from '@tanstack/react-query'

import { useAuthApi } from '@/services/api/ApiContext'

import { SOCKET_GET_URL_PATH } from '@/services'

const useGetSocketURL = (token, { enabled = true } = {}) => {
  const api = useAuthApi()

  const {
    data: socketData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ['socket-url', token],
    queryFn: () => api.get(SOCKET_GET_URL_PATH),
    select: (data) => data.data,
    enabled: enabled && !!token && !!api,
    retry: false,
  })

  const addAuthToURL = (socketURL) => {
    return `${socketURL}?Authorization=${encodeURIComponent(
      `Bearer ${token.replace('Bearer ', '')}`,
    )}`
  }

  return {
    socketData,
    isLoading,
    error,
    addAuthToURL,
    getURL: refetch,
  }
}

export default useGetSocketURL
